
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The high-level description of the HTTP request's result.`}</p>
    <p>{`Currently, four codes are defined:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`BadResponse`}</inlineCode>{` indicates the subscription endpoint returned a non-2xx HTTP response.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`InvalidUrl`}</inlineCode>{` indicates the subscription URL did not pass validation.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`RequestTimeout`}</inlineCode>{` indicates the subscription endpoint took more than 10 seconds to respond.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`Success`}</inlineCode>{` indicates the subscription endpoint returned a 2xx HTTP response.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;